'use client';

import { useTranslations } from 'next-intl';
import { useHistoryBack } from '@/lib/hooks/useHistoryBack';
import { Link } from '@/lib/routing';
import { Icon } from '@/lib/ui-kit/icons';
import { cn } from '@/lib/ui-kit/utils';

interface BackLinkProps {
  /** Same-zone target, the locale added by the router. */
  href: string;
  /** Step back through history when a page of this site is behind; `href` only otherwise. */
  historyFirst?: boolean;
  className?: string;
}

/** "← Back" over a page's content: the leaderboard's (29.09), the player profile's (19.10). */
export function BackLink({ href, historyFirst = false, className }: BackLinkProps) {
  const t = useTranslations('common');
  const handleHistoryBack = useHistoryBack();
  const handleClick = historyFirst ? handleHistoryBack : undefined;

  return (
    <Link
      href={href}
      onClick={handleClick}
      className={cn(
        `-ml-[5px] flex h-10 w-fit items-center gap-2 rounded-[10px] text-[13px] font-medium leading-4
        tracking-[-0.13px] text-v2-btn-secondary-text outline-none focus-visible:ring-2
        focus-visible:ring-v2-btn-primary`,
        className,
      )}
    >
      <span className="text-[#74797f]">
        <Icon name="ArrowSmallLeft" size={20} />
      </span>
      {t('back')}
    </Link>
  );
}
